import {ValueObject} from '@s-ui/domain'

export class DraftInstantOfferFromAPISellerValueObject extends ValueObject {
  #makeId
  #makeName
  #modelId
  #modelName
  #versionId
  #versionName
  #fuelId
  #year
  #mileage
  #postalCode
  #colorId
  #transmissionTypeId
  #bodyTypeDoors
  #condition
  #comments
  #licensePlate
  #dealerType
  #maAdId
  #email
  #name
  #phone

  constructor({
    makeId,
    makeName,
    modelId,
    modelName,
    versionId,
    versionName,
    fuelId,
    year,
    mileage,
    postalCode,
    colorId,
    transmissionTypeId,
    bodyTypeDoors,
    condition,
    comments,
    licensePlate,
    dealerType,
    maAdId,
    email,
    name,
    phone
  }) {
    super()
    this.#makeId = makeId ?? null
    this.#makeName = makeName ?? null
    this.#modelId = modelId ?? null
    this.#modelName = modelName ?? null
    this.#versionId = versionId ?? null
    this.#versionName = versionName ?? null
    this.#fuelId = fuelId ?? null
    this.#year = year ?? null
    this.#mileage = mileage ?? null
    this.#postalCode = postalCode ?? null
    this.#colorId = colorId ?? null
    this.#transmissionTypeId = transmissionTypeId ?? null
    this.#bodyTypeDoors = bodyTypeDoors ?? null
    this.#condition = condition ?? null
    this.#comments = comments ?? null
    this.#licensePlate = licensePlate ?? null
    this.#dealerType = dealerType ?? null
    this.#maAdId = maAdId ?? null
    this.#email = email ?? null
    this.#name = name ?? null
    this.#phone = phone ?? null
  }

  static create({
    makeId,
    makeName,
    modelId,
    modelName,
    versionId,
    versionName,
    fuelId,
    year,
    mileage,
    postalCode,
    colorId,
    transmissionTypeId,
    bodyTypeDoors,
    condition,
    comments,
    licensePlate,
    dealerType,
    maAdId,
    email,
    name,
    phone
  } = {}) {
    return new DraftInstantOfferFromAPISellerValueObject({
      makeId,
      makeName,
      modelId,
      modelName,
      versionId,
      versionName,
      fuelId,
      year,
      mileage,
      postalCode,
      colorId,
      transmissionTypeId,
      bodyTypeDoors,
      condition,
      comments,
      licensePlate,
      dealerType,
      maAdId,
      email,
      name,
      phone
    })
  }

  toJSON() {
    return {
      makeId: this.#makeId,
      makeName: this.#makeName,
      modelId: this.#modelId,
      modelName: this.#modelName,
      versionId: this.#versionId,
      versionName: this.#versionName,
      fuelId: this.#fuelId,
      year: this.#year,
      mileage: this.#mileage,
      postalCode: this.#postalCode,
      colorId: this.#colorId,
      transmissionTypeId: this.#transmissionTypeId,
      bodyTypeDoors: this.#bodyTypeDoors,
      condition: this.#condition,
      comments: this.#comments,
      licensePlate: this.#licensePlate,
      dealerType: this.#dealerType,
      maAdId: this.#maAdId,
      email: this.#email,
      name: this.#name,
      phone: this.#phone
    }
  }
}
